<template>
  <div class="modal-wrapper">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Cancelar cobrança
          </h4>
        </div>
        <div v-if="isBillingWithPaidHistory" class="modal-body">
          <p>Motivo do cancelamento</p>
          <select @click="errorMessage = null" v-model="interruptionReasonKey" class="form-control">
            <option v-for="(interruptionReason, index) in interruptionReasons"
                    :value="interruptionReason.key"
                    :key="index"
            >
              {{ interruptionReason.label }}
            </option>
          </select>
          <div v-if="isBillingFromParcelamento" class="modal-body-parcelamento-infos">
            <div>
              <p>O aluno possui saldo devedor?</p>
              <div class="radio-options">
                <input type="radio" id="hasDebts" value="true" v-model="selectOptionDebt">
                <label for="hasDebts" class="checkbox-itens" style="font-weight: normal;">Sim</label>

                <input type="radio" id="hasNotDebts" value="false" v-model="selectOptionDebt">
                <label for="hasNotDebts" class="checkbox-itens" style="font-weight: normal;">Não</label>
              </div>
            </div>
            <div v-if="hasDebts" class="ipca-field">
              <p>Insira a porcentagem do IPCA para o saldo devedor</p>
              <input type="number" step="0.01" v-model="ipcaValue" class="form-control" placeholder="Exemplo: 4.5">

              <div class="debt-date-field">
                <p>Insira a data de vencimento da primeira cobrança</p>
                <input type="date" v-model="debtDueDate" class="form-control" placeholder="yyy-mm-dd">
              </div>
            </div>
          </div>
        </div>
        <div v-if="!isBillingFromParcelamento" class="modal-body">
          <p>Observações</p>
          <input @click="inputError = null" class="form-input" type="text" v-model="observations">
        </div>
        <div class="modal-body-end">
          <div v-if="inputError" class="alert alert-danger">
            {{ inputError }}
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary btn-cancelar-cobranca"
                  :disabled="isButtonDisabled"
                  @click="isBillingWithPaidHistory ? interruptBilling() : cancelBilling()"
          >
            Cancelar a cobrança
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BillingsService from 'services/BillingsService';

export default {
  data() {
    return {
      observations: null,
      inputError: null,
      interruptionReasonKey: null,
      interruptionReasons: [],
      selectOptionDebt: 'false',
      debtDueDate: null,
      ipcaValue: null,
    };
  },
  mounted() {
    if (this.isBillingWithPaidHistory) {
      this.$loader.show();
      this.loadInterruptionReasons()
        .then((interruptionReasons) => {
          this.interruptionReasons = interruptionReasons;
        })
        .catch(() => {
          this.$emit('close');
          this.$alert.notifyAlert('Erro ao buscar motivos de interrupção de cobrança, tente novamente');
        })
        .finally(() => {
          this.$loader.hide();
        });
    }
  },
  props: {
    billing: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isBillingFromParcelamento() {
      return this.billing.origin === 'from_parcelamento';
    },
    isBillingWithPaidHistory() {
      return this.billing.has_paid_history;
    },
    isButtonDisabled() {
      if (this.isBillingFromParcelamento) {
        return !this.interruptionReasonKey
          || (this.selectOptionDebt === 'true' && (!this.ipcaValue || !this.debtDueDate));
      }
      return !this.observations || (this.isBillingWithPaidHistory && !this.interruptionReasonKey);
    },
    hasDebts() {
      return this.selectOptionDebt === 'true';
    },
  },
  methods: {
    ...mapActions([
      'loadStudentBillings',
      'loadStudentContracts',
      'loadStudentBills',
      'loadInterruptionReasons',
    ]),
    cancelBilling() {
      this.$loader.show();
      BillingsService.cancelBilling(this.billing.id, this.observations)
        .then(() => {
          Promise.all([
            this.loadStudentBillings(),
            this.loadStudentContracts(),
            this.loadStudentBills(),
          ]);
        })
        .then(() => this.$alert.notifySuccess('Cobrança cancelada com sucesso'))
        .catch(({ body }) => this.$alert.notifyAlert(`Erro ao cancelar a cobrança: ${body.message.$alert}`))
        .finally(() => {
          this.$emit('close');
          this.$loader.hide();
        });
    },
    interruptBilling() {
      this.$loader.show();
      BillingsService.interruptBilling(
        this.billing.id,
        this.observations,
        this.interruptionReasonKey,
        this.selectOptionDebt,
        this.ipcaValue,
        this.debtDueDate,
      )
        .then(() => {
          Promise.all([
            this.loadStudentBillings(),
            this.loadStudentContracts(),
            this.loadStudentBills(),
          ]);
        })
        .then(() => this.$alert.notifySuccess('Cobrança interrompida com sucesso'))
        .catch(({ body }) => this.$alert.notifyAlert(`Erro ao interromper a cobrança: ${body.message}`))
        .finally(() => {
          this.$emit('close');
          this.$loader.hide();
        });
    },
  },
};
</script>

<style>

.modal-body {
  padding-top: 10px;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 15px;
}

.modal-body-parcelamento-infos {
  padding-top: 20px;
}

.ipca-field {
  margin-top: 10px;
  padding-top: 4px;
}

.debt-date-field {
  margin-top: 20px;
}

.checkbox-itens {
  margin-left: 10px;
  margin-right: 10px;
}

.modal-body-end {
  margin-bottom: 10px;
}

</style>
